class SliderPress extends HTMLElement {
  constructor() {
    super();

    this.mainSliderElement = this.querySelector("[data-slider-main]");
    this.thumbsSliderElement = this.querySelector("[data-slider-thumbs]");
    this.thumbsSlidesCount = Number(
      this.thumbsSliderElement?.dataset?.slidesCount || 0
    );

    if (this.mainSliderElement && this.thumbsSliderElement) {
      this.mainSlider = new Swiper(this.mainSliderElement, {
        slidesPerView: 1,
      });

      this.thumbsSlider = new Swiper(this.thumbsSliderElement, {
        slidesPerView: this.thumbsSlidesCount,
        spaceBetween: 10,
        breakpoints: {
          990: {
            slidesPerView: 1,
          },
          1200: {
            slidesPerView: this.thumbsSlidesCount >= 2 ? 2 : this.thumbsSlidesCount,
            spaceBetween: 0,
          }
        },
      });
    }
  }
}

customElements.define("slider-press", SliderPress);
